<template>
  <IoOverlay
    v-if="!defaultDisabled || GET_COMPONENT"
    @close="close()"
  >
    <BaseCard :style="styles">
      <template #header>
        <slot name="header">
          <h5
            class="card-title"
            data-eq-part="headline"
          >
            {{ title || GET_TITLE }}
          </h5>
          <div class="form-actions">
            <BaseButtonV2
              type="link"
              color="text"
              small
              @click="close()"
            >
              <BaseIcon
                icon="fa-light fa-times"
                :style="{ fontSize: '20px' }"
              />
            </BaseButtonV2>
          </div>
        </slot>
      </template>
      <template
        v-if="!GET_COMPONENT"
        #content
      >
        <slot name="content" />
      </template>
      <template
        v-else
        #content
      >
        <component
          :is="GET_COMPONENT"
          v-bind="GET_PROPS"
          :bindings="GET_BINDINGS"
          @close="close()"
        />
      </template>
    </BaseCard>
  </IoOverlay>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: 'BaseModal',
  props: {
    title: {
      type: String,
      default: '',
    },
    bodyScroll: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      type: String,
      default: '150px',
    },
    maxHeight: {
      type: String,
      default: '80vh',
    },
    defaultDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState([
      'sidebarFixed',
    ]),
    ...mapGetters('baseModal', {
      GET_COMPONENT: 'GET_COMPONENT',
      GET_TITLE: 'GET_TITLE',
      GET_PROPS: 'GET_PROPS',
      GET_BINDINGS: 'GET_BINDINGS',
    }),
    styles() {
      return {
        'min-height': this.minHeight,
        'max-height': this.maxHeight,
        '--margin-left': this.sidebarFixed ? 'var(--sidebar-width)' : 'var(--sidebar-width-collapsed)',
      };
    },
  },
  watch: {
    GET_COMPONENT(val) {
      this.IOH.bodyScroll(!!val);
    },
  },
  mounted() {
    if (this.defaultDisabled) {
      return;
    }
    if (this.bodyScroll) {
      this.IOH.bodyScroll(true);
    }
  },
  destroyed() {
    if (this.bodyScroll) {
      this.IOH.bodyScroll(false);
    }
  },
  methods: {
    ...mapMutations('baseForm', {
      SET_DEFAULTS: 'SET_DEFAULTS',
    }),
    ...mapMutations('baseModal', {
      CLEAR: 'CLEAR',
    }),
    close() {
      this.$emit('close', false);
      if (this.bodyScroll) {
        this.IOH.bodyScroll(false);
      }
      this.CLEAR({});
      this.SET_DEFAULTS({});
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 90%;
  min-width: 800px;
  max-width: 1470px;
  transition: margin-left 225ms ease-in-out;

  @media screen and (max-width: 860px ) {
    min-width: unset;
    width: 90%;
  }
}

:deep(.card) {
  .card-body {
    overflow-y: auto;
    overflow-x: visible;
  }

  .card-header.big {
    max-height: 68px;
  }

  .card-header {
    flex: 0;
  }
}
</style>
